export default __webpack_public_path__ + "static/ak-cached/24h/media/acc_box.1f190d16.png";